import {
    getAllCustomPricingTemplates,
    getCustomPricingTemplateById,
    createUpdateCustomPricingTemplateService,
    deleteCustomPricingTemplateService,
} from '../../services/customPricingTemplate.service';
import {
    FETCH_CUSTOM_PRICING_TEMPLATES_PENDING,
    FETCH_CUSTOM_PRICING_TEMPLATES_SUCCESS,
    FETCH_CUSTOM_PRICING_TEMPLATES_FAILED,
    FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_PENDING,
    FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_SUCCESS,
    FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_FAILED,
    DELETE_CUSTOM_PRICING_TEMPLATE_SUCCESS,
} from '../constants/customPricingTemplate.constant';
import { toast } from 'react-toastify';

const normalizeCustomPricingTemplateDetail = (entity = {}) => {
    const template = entity?.customPricingTemplate;
    const rate = entity?.customPricingRate;

    if (!template) {
        return entity;
    }

    // customPricingRate comes back as an array (one entry per rate row), not a
    // single object — normalize the single-object shape too in case an older
    // response variant sends one.
    let rateEntries = [];
    if (Array.isArray(rate)) {
        rateEntries = rate;
    } else if (rate) {
        rateEntries = [rate];
    }

    const rateGrid = rateEntries.map((r) => ({
        transactionType: r?.transactionTypeId || '',
        chargeType: r?.chargeTypeId || '',
        size: r?.sizeTypeId || '',
        chargeUnit: r?.unitId || '',
        validFrom: r?.validFrom || null,
        validTo: r?.validTo || null,
        amount: r?.amount ?? '',
        additionalCharge: r?.additionalCharge ?? '',
    }));

    return {
        templateName: template?.templateName || '',
        serviceTypeMasterId: template?.serviceTypeMasterId || 0,
        subServiceTypeIds: template?.subServiceTypeIds || [],
        warehouseIds: template?.warehouseList || [],
        skuProductIds: template?.skuProductIds || [],
        companyIds: template?.companyIdList || [],
        sellerIds: template?.sellerIdList || [],
        carrierConnectIdList: template?.carrierConnectIdList || [],
        carrierConnectDetails: template?.carrierConnectDetails || [],
        rateGrid,
    };
};

export const fetchAllCustomPricingTemplates = (data) => async (dispatch) => {
    dispatch({ type: FETCH_CUSTOM_PRICING_TEMPLATES_PENDING });
    try {
        const response = await getAllCustomPricingTemplates(data);
        if (response?.data?.Status === 200) {
            dispatch({ type: FETCH_CUSTOM_PRICING_TEMPLATES_SUCCESS, payload: response.data });
        } else {
            dispatch({ type: FETCH_CUSTOM_PRICING_TEMPLATES_FAILED });
        }
    } catch {
        dispatch({ type: FETCH_CUSTOM_PRICING_TEMPLATES_FAILED });
    }
};

export const fetchCustomPricingTemplateById = (id) => async (dispatch) => {
    dispatch({ type: FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_PENDING });
    try {
        const response = await getCustomPricingTemplateById(id);
        if (response?.data?.Status === 200) {
            dispatch({
                type: FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_SUCCESS,
                payload: normalizeCustomPricingTemplateDetail(response.data.Entity),
            });
        } else {
            dispatch({ type: FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_FAILED });
        }
    } catch {
        dispatch({ type: FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_FAILED });
    }
};

export const createUpdateCustomPricingTemplate = (data) => async (dispatch) => {
    try {
        const response = await createUpdateCustomPricingTemplateService(data);
        if (response?.data?.Status === 200) {
            return response.data;
        }
        toast.error(response?.data?.Message?.AppStatusDescription || 'Failed to save template');
        return null;
    } catch {
        toast.error('Failed to save template');
        return null;
    }
};

export const deleteCustomPricingTemplate = (id) => async (dispatch) => {
    try {
        const response = await deleteCustomPricingTemplateService(id);
        if (response?.data?.Status === 200) {
            dispatch({ type: DELETE_CUSTOM_PRICING_TEMPLATE_SUCCESS, payload: id });
            toast.success('Template deleted successfully');
            return true;
        }
        toast.error(response?.data?.Message || 'Failed to delete template');
        return false;
    } catch {
        toast.error('Failed to delete template');
        return false;
    }
};
